import { ParentSize } from '@visx/responsive';
import { FC } from 'react';

export type ResponsiveContainerProps<T> = {
  component: FC<Omit<T, 'component'> & { width: number; height: number }>;
} & T;

/**
 * @deprecated Use ParentSize component directly
 */
export const ResponsiveContainer = <T extends { [K in keyof T]: T[K] }>(
  props: ResponsiveContainerProps<T>
) => {
  const { component: Component, ...rest } = props;

  return (
    <ParentSize>
      {({ width, height }) => <Component height={height} width={width} {...rest} />}
    </ParentSize>
  );
};
